export default __webpack_public_path__ + "static/media/Button_Info.6f2047dd.svg";